import classNames from 'classnames'
import { observer } from 'mobx-react'
import GlobalState from '../../../../stores/GlobalState'
import './index.scss'
import { Fragment, useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import ContentState from '../../../../stores/ContentState'

const TariffsResult = observer(({ list }: { list: any }) => {
  const ref = useRef<any>(null)
  const [width, setWidth] = useState(window.innerWidth)

  const endDay = GlobalState.currentLocale.lang.includes('En')
    ? ['day', 'days']
    : GlobalState.currentLocale.lang.includes('ру')
    ? ['день', 'дня', 'дней']
    : ['день', 'дні', 'днів']

  const currency = ['₴', '$']

  const getEndOfDay = (li: string) => {
    const lang = GlobalState.currentLocale.lang
    if (li.includes('-')) {
      const [p1, p2] = li.trim().split('-')
      if (+p1 >= 1 && +p2 < 5) return endDay[1]
      if (+p1 >= 1 && +p2 >= 5)
        return lang.includes('En') ? endDay[1] : endDay[2]
    } else {
      if (+li == 1) return endDay[0]
      if (+li > 1 && +li < 5) return endDay[1]
      if (+li > 4 || !+li) return lang.includes('En') ? endDay[1] : endDay[2]
    }
    if (+li == 1) return endDay[0]
    if (+li > 1 && +li < 5) return endDay[1]
    if (+li > 4) return lang.includes('En') ? endDay[1] : endDay[2]
    return endDay[0]
  }

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  if (!ContentState.tariffs?.result) return <></>

  const content = {
    ...ContentState.tariffs.result,
    list: list,
  }

  return (
    <div className="tariffs-result" ref={ref}>
      <div className="tariffs__title">{ContentState.tariffs?.title}</div>
      {width > 660 ? (
        <table className="tariffs-result__table">
          <thead>
            {content.headlines.map((h: any, i: number) => (
              <td className="tariffs-result__title" key={i}>
                {h}
              </td>
            ))}
            <td className="tariffs-result__title">
              {' '}
              <div className="button black">{content.buttonTitle}</div>
            </td>
          </thead>
          <tbody>
            {content.list ? (
              content.list.map((l: any, i: number) => (
                <tr key={i}>
                  {l.map((li: any, id: number) => (
                    <Fragment key={id}>
                      <td
                        className={classNames(
                          'tariffs-result__text',
                          id && 'red-text',
                        )}
                      >
                        {!id ? (
                          <>{li}</>
                        ) : (
                          <>
                            {li}{' '}
                            {id == 2
                              ? li
                                ? getEndOfDay(li)
                                : ''
                              : ' ' + currency[0]}
                          </>
                        )}
                      </td>
                      {id == 2 && (
                        <td className="tariffs-result__text">
                          <a
                            className="button black"
                            href={content.buttonLink}
                            target={
                              content.buttonLink.includes('http')
                                ? '_blank'
                                : ''
                            }
                          >
                            {content.buttonTitle}
                          </a>
                        </td>
                      )}
                    </Fragment>
                  ))}
                </tr>
              ))
            ) : (
              <>
                {GlobalState.currentLocale.lang.includes('En')
                  ? 'No found by your request'
                  : 'За вашим запитом нічого не знайдено'}
              </>
            )}
          </tbody>
        </table>
      ) : (
        <div className="tariffs-result__block">
          {content.list.map((l: any, i: number) => (
            <div className="tariffs-result__block-col" key={i}>
              <div className="tariffs-result__block-top">{l[0]}</div>
              <div className="tariffs-result__block-row">
                <div>{content.headlines[1]}</div>{' '}
                <span>
                  {l[1]} {currency[0]}
                </span>
              </div>
              <div className="tariffs-result__block-row">
                <div>{content.headlines[2]}</div>{' '}
                <span>
                  {l[2]} {l[2] ? getEndOfDay(l[2]) : ''}
                </span>
              </div>
              <a
                className="button black"
                href={content.buttonLink}
                target={content.buttonLink.includes('http') ? '_blank' : ''}
              >
                {content.buttonTitle}
              </a>
            </div>
          ))}
        </div>
      )}
      <div className="tariffs-result__info">
        <div className="tariffs-result__subtitle">
          {content.moreTitle}{' '}
          <span
            dangerouslySetInnerHTML={{ __html: content.servicesPage }}
          ></span>
        </div>
        <div
          className="tariffs-result__info-text"
          dangerouslySetInnerHTML={{ __html: content.info }}
        ></div>
        <div
          className="tariffs-result__info-list"
          dangerouslySetInnerHTML={{ __html: content.infoList }}
        ></div>
      </div>
    </div>
  )
})

export default TariffsResult
